module.exports = {
  BackToMain: 'Quay lại màn hình chính',
  UserInfo: 'Thông tin cá nhân',
  Individual: 'Tùy chỉnh trang',
  Cache: 'Bộ nhớ đệm',
  Authorize: 'Ủy quyền',
  CNName: 'Tên tiếng Trung:',
  Phone: 'Điện thoại:',
  ENName: 'Tên tiếng Anh:',
  Tel: 'Số điện thoại:',
  Email: 'Email:',
  QQ: 'QQ:',
  MyInfo: 'Hồ sơ cá nhân',
  PersonalEmailSettings: 'Cài đặt email cá nhân',
  EmailPassword: 'Mật khẩu email/Mã ủy quyền:',
  SignatureSetup: 'Cài đặt chữ ký',
  ToEnableTheSignature: 'Bật chữ ký',
  SendTest: 'Gửi thử',
  Edit: 'Chỉnh sửa',
  Save: 'Lưu',
  Cancel: 'Hủy',
  ChangePsd: 'Đổi mật khẩu',
  ErrorRaised: 'Đã xảy ra lỗi.',
  SaveSucceed: 'Lưu thành công.',
  ResetJobCopySucceed: 'Đã có thể thiết lập lại điều kiện sao chép trang',
  CancelChange: 'Xác nhận hủy thay đổi hiện tại?',
  Name: 'Tên',
  company: 'Công ty',
  platformId: 'ID nền tảng',
  department: 'Phòng ban',
  Version: 'Phiên bản',
  Amount: 'Tổng số',
  Filter: 'Tìm kiếm:',
  RefreshCache: 'Làm mới bộ nhớ đệm',
  ResetCache: 'Đặt lại bộ nhớ đệm',
  Refresh: 'Làm mới',
  Reset: 'Đặt lại',
  Detail: 'Xem',
  UserName: 'Họ tên',
  LoginTime: 'Thời gian đăng nhập',
  ExitTime: 'Thao tác cuối',
  BackToMyAccount: 'Thoát tài khoản ủy quyền',
  AuthHistory: 'Lịch sử sử dụng ủy quyền',
  User: 'Người dùng',
  NewAuth: 'Ủy quyền',
  BeginDate: 'Ngày bắt đầu',
  EndDate: 'Ngày kết thúc',
  CancalAuth: 'Thu hồi ủy quyền',
  UseAuth: 'Sử dụng ủy quyền',
  AuthOwned: 'Ủy quyền hiện có',
  AuthFail: 'Ủy quyền thất bại',
  ConfirmAuth: 'Xác nhận ủy quyền',
  InputAuthReason: 'Vui lòng nhập lý do ủy quyền',
  AdminUse: 'Đăng nhập quản trị viên:',
  InvalidUser: 'Vui lòng nhập đúng tên người dùng và ngày tháng!',
  AuthMyself: 'Không thể tự ủy quyền cho chính mình!',
  InputUser: 'Vui lòng nhập tên người dùng muốn ủy quyền!',
  Tips: 'Thông báo',
  SaveYourChange: 'Có dữ liệu thay đổi chưa được lưu, vui lòng đóng tất cả các module đang mở trước khi thoát tài khoản ủy quyền!',
  ShutModule: 'Vui lòng đóng các module đang mở trước khi thoát tài khoản ủy quyền, hiện có {0} module đang mở, đóng tất cả?',
  LoginMySelf: 'Không cần đăng nhập lặp lại tài khoản của mình!',
  SelectAccout: 'Vui lòng nhập tài khoản bạn muốn đăng nhập!',
  TableColor: 'Màu bảng',
  StatusName: 'Tên trạng thái',
  ColorValue: 'Giá trị màu',
  PartnerDisplayControl: 'Kiểm soát hiển thị dữ liệu',
  PartnerCategory: 'Loại dữ liệu',
  Chinese: 'Tiếng Trung',
  English: 'Tiếng Anh',
  Code: 'Mã',
  EnglishAndChinese: 'Tiếng Anh + Tiếng Trung',
  ChineseAndEnglish: 'Tiếng Trung + Tiếng Anh',
  ShortName: 'Tên viết tắt',
  CodeAndChinese: 'Mã + Tiếng Trung',
  CodeAndEnglish: 'Mã + Tiếng Anh',
  ShortNameAndChinese: 'Tên viết tắt + Tiếng Trung',
  YouDoNotHaveAccessToTheAdministratorAccount: 'Bạn không có quyền truy cập tài khoản quản trị viên',
  Setting: 'C.đặt',
  VerificationSettings: 'Cấu hình Pop-up Xác thực',
  ResetJobCopyTittle: 'Thiết lập lại điều kiện trang',
  ResetJobCopyMessage: 'Sau khi nhấp nút cài đặt, hộp thoại thiết lập điều kiện sao chép sẽ hiển thị lại khi sao chép, có thể thiết lập lại điều kiện sao chép',
  RepeatCopyMessage: 'Đã có tên phí giống nhau, có muốn sao chép lại không?',
  WeChatPushRemindTitle: 'Vui lòng quét mã QR dưới đây và theo dõi tài khoản công khai "WallTech Thông tin"',
  WeChatPushRemind1: 'Đảm bảo bạn đã theo dõi tài khoản công khai "WallTech Thông tin", nếu không sẽ không nhận được tin nhắn WeChat.',
  WeChatPushRemind2: 'Tin nhắn WeChat có thể bị trễ, mọi thông tin lấy theo hiển thị trên trang web.',
  IveFollowed: 'Tôi đã theo dõi',
  CheckedCategory: 'Loại mục chọn',
  AfterCheckedSelection: 'Sau khi nhấp nút đặt lại, trang chọn đại lý sẽ hiển thị lại khi mua bảo hiểm, có thể thiết lập lại tùy chọn đại lý',
  FreightInsuranceProvider: 'Nhà cung cấp bảo hiểm hàng hóa',
  ResetFreightInsuranceProvider: 'Đặt lại nhà cung cấp bảo hiểm hàng hóa',
  FreightInsuranceProviderReset: 'Đã đặt lại tùy chọn nhà cung cấp bảo hiểm hàng hóa',
  CopyBusiness: 'Sao chép nghiệp vụ',
  UseSsl: 'Bật chế độ SSL',
  Japanese: 'Tiếng Nhật',
  CustomerSupplierNoChinese: 'Mã khách hàng/Mã nhà cung cấp + Tiếng Trung',
  threeCharacterCode: 'Tên viết tắt + Mã ba chữ',
  threeCharacterCodeTooltip: 'Mã ba chữ: MAWB Prefix',
  CustomerNoChinese: 'Mã khách hàng + Tiếng Trung',
  SupplierNoChinese: 'Mã nhà cung cấp + Tiếng Trung',
  pageDisplay: 'Hiển thị trang',
  required: 'Có bắt buộc không',
  b2bWebsite: 'Trang web B2B',
  b2bWebsiteDisplay: 'Hiển thị trang web B2B'
}
